import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  Pagination,
  ReferenceManyField,
  TextField,
  useGetManyReference,
  useRecordContext,
} from "react-admin";
import { Typography } from "@mui/material";

const GetInvitationHistory = ({ reference = "onpoint_extraction_software_invitation_history" }) => {
  const record = useRecordContext();
  const { data, isLoading } = useGetManyReference(reference, {
    target: 'master_customer_id',
    id: record?.id,
    pagination: { page: 1, perPage: 10 },
    sort: { field: 'id', order: 'DESC' },
  });

  if (isLoading) return null;

  if (!data || data.length === 0) {
    return <Typography sx={{ m: 2 }}>No OnPoint invitations found</Typography>;
  }

  return (
    <ReferenceManyField
      fullWidth
      label="Invitations"
      reference={reference}
      target="master_customer_id"
      source="id"
      perPage={10}
      sort={{ field: "id", order: "DESC" }}
      pagination={<Pagination />}
    >
      <Datagrid>
        <TextField source="id" label="ID" />
        <DateField
          source="date_added"
          label="Date Added"
          showTime
        />
        <TextField source="status" />
        <TextField source="store_name" label="Current Store Name" />
        <TextField source="invitation_email_send_to" label="Invitation Email" />
        <TextField source="recipient_name" label="Recipient" />
        <BooleanField source="accepted_center_store_participation" label="Accepted Center Store Participation" />
        <BooleanField source="interested_in_patron_points_tobacco" label="Interested in Patron Points Tobacco" />
        <BooleanField source="accepted_eula" label="Accepted EULA" />
        <DateField
          source="registration_completed_date"
          label="Registration Completed Date"
          showTime
        />
        <TextField source="distributor_id" label="Distributor ID" />
        <TextField source="distributor_name" label="Distributor Name" />
        <TextField source="warehouse_name" label="Warehouse Name" />
        <FunctionField
          source="email_list"
          label="Email List"
          render={(record) => {
            const emails = record.email_list;
            if (!emails || typeof emails !== "object") return null;
            return Object.keys(emails).filter(key => emails[key] === true).join(", ");
          }}
        />
        <TextField source="operation_type" label="Operation Type" />
        <DateField
          source="changed_at"
          label="Changed At"
          showTime
        />
      </Datagrid>
    </ReferenceManyField>
  );
};

export default GetInvitationHistory;
